import { useState } from "react";
import { Any } from "@cede/types";
import { StoreMethodMetaData } from "../../constants/methods";
import { useParamsForms } from "../../hooks/useParamsForms/useParamsForms";
import { UserFieldGroup } from "./UserFieldsGroup";
import { JsonField } from "./fields/JsonField";
import { ResultField, ResultFieldState } from "./fields/ResultField";
import { Button, Card, useTheme } from "@mui/material";

export type ActionCardProps = {
  req: (params?: any) => Promise<any>;
  id: string;
  method: StoreMethodMetaData;
};

export const ActionCard = ({ req, id, method }: ActionCardProps) => {
  const theme = useTheme();
  const [result, setResult] = useState<Any>(null);
  const [state, setState] = useState<ResultFieldState>("neutral");
  const mode = useParamsForms((state) => state.mode);
  const form = useParamsForms((state) => state.forms[method.methodName]);

  const onSubmit = async () => {
    try {
      setResult(await req(form));
      setState("success");
    } catch (err) {
      setState("error");
      setResult(JSON.parse(JSON.stringify(err, ["message", "code", "description", "data"])));
    }
  };

  return (
    <Card
      data-testid={`actionCard-${id}`}
      sx={{
        bgcolor: theme.palette.background.component,
        borderRadius: theme.custom.largeBoxRadius,
        padding: theme.custom.gutterMargin,
        display: "flex",
        flexDirection: "column",
        gap: theme.custom.gutterMargin,
      }}
    >
      <Button
        data-testid={`button-${id}`}
        variant="contained"
        sx={{
          backgroundColor: theme.palette.primaryDarkBlue,
          color: theme.palette.text.primary,
          borderRadius: theme.custom.buttonDefaultRadius,
          padding: "0 0.5rem",
          height: "36px",
          textTransform: "none",
        }}
        onClick={onSubmit}
      >
        {method.actionName.toLocaleUpperCase()}
      </Button>
      {method.params && mode === "user" && <UserFieldGroup method={method} id={id} />}

      {method.params && mode === "json" && <JsonField method={method} />}
      <ResultField result={result} state={state} id={id} />
    </Card>
  );
};
